import { Avatar, Space } from 'antd';
import React from 'react';
import { getDataDetail, getImageUrl } from 'utils/tools';

const VariantNameItem = ({ item }) => {
  return (
    <Space size={15}>
      <Avatar
        src={getImageUrl(item?.variant?.thumbnail || item?.product?.thumbnail)}
        shape="square"
        size={40}
      />
      <div>
        <div className="fw-500 text-title-gray text-sm">
          {item?.variantName || item?.productName || getDataDetail(item)?.name}
        </div>

        <div className="text-subtitle-gray text-sm fw-400">
          {item?.variant?.attributeValues
            ?.map((e) => getDataDetail(e)?.name)
            .join('/')}
        </div>
        <div className="text-subtitle-gray text-sm fw-400">
          {item.variantSku}
        </div>
      </div>
    </Space>
  );
};

export default VariantNameItem;
